/******************************************************************************
 * Copyright (c) 2016 - 2021.                                                 *
 * Yega Yazilim ve Bilisim Hizmetleri Dis Tic Ltd Sti (Yega Yazilim)          *
 * All Rights Reserved.                                                       *
 *                                                                            *
 * The software and data contained herein are confidential and proprietary    *
 * information of Yega Yazilim ("Confidential Information").                  *
 *                                                                            *
 * Users of this software may not disclose such Confidential Information and  *
 * shall use it only in accordance with the terms of the license agreement    *
 * they entered into with Yega Yazilim.                                       *
 *                                                                            *
 * Author:  Ahmet Dogramaci                                                   *
 * Date:    2021-03-03                                                        *
 ******************************************************************************/

import storeGenerator from '../../utils/store-generator'
import spinner_axios from "../../utils/spinner-axios";

let customActions = {
    update_status(context, item) {
        return new Promise(callAxios);

        function callAxios(resolve, reject) {
            spinner_axios
                .put(`/v2/quote_versions/${item.id}/update_status`, item)
                .then(success)
                .catch(failure);

            function success(response) {
                resolve(response.data);
                context.commit('one', response.data);
            }

            function failure(error) {
                console.log(error.response ? error.response.data : error);
                reject(error);
            }
        }
    },
    workflow_progress(context, id) {
        return new Promise(callAxios);

        function callAxios(resolve, reject) {
            spinner_axios
                .get(`/v2/quote_versions/${id}/workflow_progress`)
                .then(success)
                .catch(failure);

            function success(response) {
                resolve(response.data);
            }

            function failure(error) {
                console.log(error.response ? error.response.data : error);
                reject(error);
            }
        }
    },
    submit_for_approval(context, item) {
        return new Promise(callAxios);

        function callAxios(resolve, reject) {
            spinner_axios
                .put('/v2/quote_versions/' + item.id + '/submit_for_approval')
                .then(success)
                .catch(failure);

            function success(response) {
                context.commit('one', response.data);
                resolve(response.data);
            }

            function failure(error) {
                console.log(error.response ? error.response.data : error);
                reject(error);
            }
        }
    },
    custom_action(context, { action, params }) {
        return new Promise(callAxios);

        function callAxios(resolve, reject) {
            const queryString = new URLSearchParams(params).toString();
            const url = `/v2/quote_versions/${action}${queryString ? '?' + queryString : ''}`;

            spinner_axios
                .get(url)
                .then(success)
                .catch(failure);

            function success(response) {
                resolve(response.data);
            }

            function failure(error) {
                console.log(error.response ? error.response.data : error);
                reject(error);
            }
        }
    }
}
const QuoteVersionsStore = storeGenerator('/v2/quote_versions',null,customActions);
export default QuoteVersionsStore;
